import { render, staticRenderFns } from "./ignorePlace.vue?vue&type=template&id=906d582c&"
import script from "./ignorePlace.vue?vue&type=script&lang=js&"
export * from "./ignorePlace.vue?vue&type=script&lang=js&"
import style0 from "./ignorePlace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports